import React from 'react';
import './SpeechTherapy.css';

const SpeechTherapy = () => {
  return (
    <div className="residential-treatment-container">
      <div className="main-title">Speech Therapy at The Helping Hand Psychological Hospital</div>
      <div className="paragraph">
        At The Helping Hand Psychological Hospital, we understand that effective communication is an essential part of everyday life. Our Speech Therapy services are designed to help children and adults overcome speech, language, communication, voice, and swallowing difficulties. Our experienced speech therapists work closely with each client and their family to provide personalized care that supports confidence, independence, and overall well-being.
      </div>

      <div className="sub-title">Our Areas of Expertise</div>
      <div className="paragraph">
        Our speech therapists provide assessment and intervention for a wide range of communication needs, including:
      </div>
      <ul className="bullet-points">
        <li>Speech sound disorders</li>
        <li>Language delays and language disorders</li>
        <li>Stuttering (Stammering)</li>
        <li>Voice disorders</li>
        <li>Social communication difficulties</li>
        <li>Autism Spectrum Disorder (ASD)</li>
        <li>Developmental communication delays</li>
        <li>Feeding and swallowing difficulties</li>
        <li>Communication challenges following neurological conditions</li>
      </ul>

      <div className="sub-title">Our Services</div>
      <div className="paragraph">
        We offer comprehensive speech therapy services, including:
      </div>
      <ul className="bullet-points">
        <li>Speech and language assessments</li>
        <li>Individual therapy sessions</li>
        <li>Early intervention programmes</li>
        <li>Parent and caregiver guidance</li>
        <li>School readiness and literacy support</li>
        <li>Social communication skills training</li>
        <li>Feeding and swallowing therapy</li>
        <li>Home-based therapy programmes and progress reviews</li>
      </ul>

      <div className="sub-title">Our Commitment to Better Communication</div>
      <div className="paragraph">
        We believe that every individual deserves the opportunity to communicate with confidence. Our goal is to provide compassionate, evidence-based care in a supportive environment while working closely with families, schools, and other healthcare professionals. Together, we help our clients build communication skills that improve their daily lives and future opportunities.
      </div>
    </div>
  );
};

export default SpeechTherapy;
